import * as HttpUtils from 'utils/HttpUtils'
import * as ListUtils from 'utils/ListUtils'
import FormConst from 'constants/FormConst'
import URLConst from 'constants/URLConst'
import { runInAction } from "mobx"
import { makeAutoObservable } from "mobx"

/*
 * Module - MemberStore.js
 *
 * Description : 이지로드 회원 관련 스터어 입니다. 
 *
 * 작성자 : Choi young ho. 
 * Created on Fri Jan 21 2022
 * Copyright (c) 2022 Renewhouse corp
 */
export default class MemberStore {

    constructor(root) {
        this.root = root;
        this.initState();
        makeAutoObservable(this)
    }

    initState = () => {
        this.userInfo = null;   
        this.lst = []; 
    }

    /**
     * 회원 검색을 
     * 서버에 요청 합니다. 
     * @param {*} searchField 
     * @param {*} searchKeyword
     * @param {*} pageNo 
     * @param {*} pageAmount 
     * @param {*} regState 
     * @returns 
     */
    doSearch = async ({
        searchField,
        searchKeyword,
        pageNo,
        pageAmount,
        regState
     }) => {
        let param = {};
        param[FormConst.SEARCH_FIELD] = searchField;
        param[FormConst.SEARCH_KEYWORD] = searchKeyword;
        param[FormConst.jqGRID_JSON_PROTOCOL_CURRERNT_PAGE] = pageNo;
        param[FormConst.jqGRID_JSON_PROTOCOL_RECORD_AMOUNT] = pageAmount;
        param[FormConst.REG_STATE] = regState;

        let result = await HttpUtils.doPostFormData(
            URLConst.ADMIN_MEMBER_SEARCH_JSON, 
            param
        );
        
        let lst = ListUtils.replaceOrMergeList(
            this.lst,
            result[FormConst.LIST_FIELD],
            pageNo, 
            pageAmount, 
            // searchKeywordList.length, 
            (searchField == "") ? 0 : 1,
            this.setDataInited, 
            this.setNoResult, 
            this.setLastPage,
        ); 
        runInAction(() => {
            this.lst = lst;
        });
        
        return result;
    }
}